module.exports = __webpack_public_path__ + "img/lauren-coffaro.37ac0514.jpg";